import { FormatPhone, TextInput } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import EmailAdicional from 'app/main/pessoa/Contato/EmailAdicional';
import TelefoneAdicional from 'app/main/pessoa/Contato/TelefoneAdicional';
import { FieldArray, useFormikContext } from 'formik';
import React from 'react';

const Contato = ({ contato, index, onChange, onBlur, errors, touched, submitCount }) => {
  const contatosErrors = errors?.pessoa?.contatos || [{}];
  const contatosTouched = touched?.pessoa?.contatos || [{}];
  const { email: emailError, emailsAdicionais: emailsAdicionaisErrors } = contatosErrors[index];
  const { email: emailTouched, emailsAdicionais: emailsAdicionaisTouched } = contatosTouched[index];

  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          autoFocus
          id={`pessoa.contatos[${index}].nomeReferencia`}
          fullWidth
          onChange={onChange}
          onBlur={onBlur}
          value={contato.nomeReferencia}
          label="Nome do contato"
          error={errors?.pessoa?.contatos?.length > index && errors.pessoa.contatos[index].nomeReferencia}
          touched={
            errors?.pessoa?.contatos?.length > index &&
            (submitCount > 0 || (touched?.pessoa?.contatos?.length && touched.pessoa.contatos[index].nomeReferencia)) &&
            errors.pessoa.contatos[index].nomeReferencia
          }
          maxLength={30}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextInput
            id={`pessoa.contatos[${index}].numero`}
            fullWidth
            onChange={onChange}
            onBlur={onBlur}
            value={contato.numero}
            label="Telefone principal"
            InputProps={{ inputComponent: FormatPhone }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TelefoneAdicional
            contatoIndex={index}
            telefonesAdicionais={contato.telefonesAdicionais}
            handleChange={onChange}
            handleBlur={onBlur}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextInput
            id={`pessoa.contatos[${index}].email`}
            // required={contato.email && emailTouched && emailError}
            fullWidth
            label="E-mail principal"
            onChange={onChange}
            onBlur={onBlur}
            value={contato.email}
            maxLength={100}
            touched={emailTouched}
            error={emailError}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <EmailAdicional
            contatoIndex={index}
            emailsAdicionais={contato.emailsAdicionais}
            error={emailsAdicionaisErrors}
            touched={emailsAdicionaisTouched}
            handleChange={onChange}
            handleBlur={onBlur}
          />
        </Grid>
      </Grid>
    </>
  );
};

const TabContato = () => {
  const formikContext = useFormikContext();
  const { values, handleChange, handleBlur, errors, touched, submitCount } = formikContext;
  const { pessoa = {} } = values;
  const { contatos = [{}] } = pessoa;

  return (
    <FieldArray name="contatos">
      {(arrayHelpers) => {
        return contatos.map((contato, index) => {
          return (
            <Contato
              key={index}
              index={index}
              contato={contato}
              arrayHelpers={arrayHelpers}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              submitCount={submitCount}
            />
          );
        });
      }}
    </FieldArray>
  );
};

export default TabContato;
